<template>
    <div v-if="isOpen" class="modal fade show vh-modal" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header py-1 px-2">
                    <h1 class="vh-title mb-0">Version History</h1>
                    <button type="button" class="btn-close" aria-label="Close" @click="emit('close')"></button>
                </div>
                <div class="modal-body px-2 pb-2">
                    <div class="table-responsive">
                        <table class="table vh-table">
                            <thead>
                            <tr>
                                <th>Version</th>
                                <th class="text-center">Status</th>
                                <th class="text-end">Amount</th>
                                <th>Created</th>
                                <th>Approved</th>
                                <th>Note</th>
                                <th class="text-end">Export</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="version in versions" :key="version.id">
                                <td class="vh-no">V{{ version.version_no }}</td>
                                <td class="text-center"><StatusChip :status="version.status" :tones="budgetVersionTones"/></td>
                                <td class="text-end text-nowrap">{{ commaFormat(version.total_amount) }}</td>
                                <td>
                                    <div>{{ formatDateTimeLabel(version.created_at) }}</div>
                                    <div class="vh-sub">{{ version.created_by_name }}</div>
                                </td>
                                <td>
                                    <div>{{ formatDateTimeLabel(version.approved_at) }}</div>
                                    <div class="vh-sub">{{ version.approved_by_name }}</div>
                                </td>
                                <td class="vh-note">{{ version.note }}</td>
                                <td class="text-end">
                                    <button
                                        type="button"
                                        class="vh-export"
                                        title="Download this version"
                                        :disabled="exportingVersionId === version.id"
                                        @click="emit('export', version)"
                                    >
                                        <span v-if="exportingVersionId === version.id" class="spinner-border spinner-border-sm" role="status"></span>
                                        <span v-if="exportingVersionId !== version.id"><i class="fa-solid fa-download"></i></span>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import StatusChip from '@/components/atom/StatusChip.vue'
import figureFormatter from '@/services/utils/figureFormatter'
import { budgetVersionTones, formatDateTimeLabel } from '@/services/utils/global.js'

defineProps({
    isOpen: {
        type: Boolean,
        default: false
    },
    versions: {
        type: Array,
        default: () => []
    },
    exportingVersionId: {
        type: Number,
        default: null
    }
})

const emit = defineEmits(['close', 'export'])

const { commaFormat } = figureFormatter()
</script>

<style scoped>
.vh-title {
    font-size: 18px;
    font-weight: 700;
    color: #101828;
}
.vh-table {
    margin-bottom: 0;
}
.vh-table thead th {
    padding: 10px 12px;
    background: #f9fafb;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .04em;
    text-transform: uppercase;
    color: #475467;
    white-space: nowrap;
}
.vh-table tbody td {
    padding: 12px;
    font-size: 14px;
    color: #344054;
    vertical-align: middle;
}
.vh-no {
    font-weight: 700;
    color: #101828;
}
.vh-sub {
    font-size: 13px;
    color: #667085;
}
.vh-note {
    max-width: 220px;
    white-space: pre-wrap;
    word-break: break-word;
}
.vh-export {
    width: 34px;
    height: 34px;
    border: 1px solid #e4e7ec;
    border-radius: 8px;
    background: #fff;
    color: #7367f0;
}
.vh-export:hover:not(:disabled) {
    border-color: #7367f0;
    background: #f4f3ff;
}
</style>
